export { default as Investment } from './Investment'
export { default as Investments } from './Investments'
